const icons = {
  BACK: "mdi-arrow-left",
  CHECK: "mdi-check",
  PLUS: "mdi-plus",
  CLOSE: "mdi-close",
  CHEVRON_RIGHT: "mdi-chevron-right",
  CHEVRON_LEFT: "mdi-chevron-left",
  CHEVRON_DOWN: "mdi-chevron-down",
  CHEVRON_UP: "mdi-chevron-up",
  LOGOUT: "mdi-logout",
  ENVELOPE: "mdi-email-outline",
  EYE: "mdi-eye",
  EYE_OFF: "mdi-eye-off",
  SNB_SUCCESS: "mdi-check-underline",
  SNB_ERROR: "mdi-close-octagon",
  SNB_INFO: "mdi-information",
  SNB_WARNING: "mdi-alert",
  ALERT_CIRCLE: "mdi-alert-circle-outline",
  MENU: "mdi-menu",
  HOME: "mdi-home",
  CALENDAR: "mdi-calendar",
  CLOCK_OUTLINE: "mdi-clock-outline",
  FLASH: "mdi-flash",
  MAP_MARKER: "mdi-map-marker-outline",
  STETHOSCOPE: "mdi-stethoscope",
  CELLPHONE: "mdi-cellphone",
  PHONE: "mdi-phone",
  HOSPITAL_BUILDING: "mdi-hospital-building",
  VIDEO: "mdi-video-outline",
  ACCOUNT: "mdi-account",
  DOCTOR: "mdi-doctor",
  FILE: "mdi-file-document-outline",
  FLASK_OUTLINE: "mdi-flask-outline",
  GROUP: "mdi-account-group",
  ACCOUNT_MULTIPLE: "mdi-account-multiple",
  ACCOUNT_PLUS_OUTLINE: "mdi-account-plus-outline",
  DELETE: "mdi-trash-can-outline",
  CHANGE_PASSWORD: "mdi-lock-reset",
  HELP_OUTLINE: "mdi-help-circle-outline",
  VIEW_DASHBOARD: "mdi-view-dashboard",
  ACCOUNT_OUTLINE: "mdi-account-circle-outline",
  ACCOUNT_SUPERVISOR_CIRCLE: "mdi-account-supervisor-circle",
  THEME_LIGHT_DARK: "mdi-theme-light-dark",
  CARD_ACCOUNT_DETAILS_OUTLINE: "mdi-card-account-details-outline",
  ALL_INCLUSIVE: "mdi-all-inclusive",
  TUNE: "mdi-tune",
  MAGNIFY: "mdi-magnify",
  REMOVE_FILTERS: "mdi-filter-remove-outline",
  DOWNLOAD: "mdi-download",
  UPLOAD_FILE: "mdi-file-upload-outline",
  TURNOS_PENDIENTES: "mdi-calendar-clock-outline",
  HISTORIAL: "mdi-history",
  OPEN_IN_NEW: "mdi-open-in-new",
  LINK: "mdi-link-variant",
  FILE_PDF_BOX: "mdi-file-pdf-box",
  FOLDER_OUTLINE: "mdi-folder-outline",
  CLIPBOARD_PULSE_OUTLINE: "mdi-clipboard-pulse-outline",
  NOTE_EDIT_OUTLINE: "mdi-note-edit-outline",
};

export const PORTAL_MODULE_MENU_ICONS = Object.freeze({
  appointments: icons.CALENDAR,
  patientdata: icons.ACCOUNT,
  diagimgreports: icons.FILE,
  labreports: icons.FLASK_OUTLINE,
  externallabreports: icons.FLASK_OUTLINE,
  patient: icons.CARD_ACCOUNT_DETAILS_OUTLINE,
  familygroup: icons.GROUP,
  changepassword: icons.CHANGE_PASSWORD,
  help: icons.HELP_OUTLINE,
  otherdocuments: icons.FOLDER_OUTLINE,
  admissions: icons.CLIPBOARD_PULSE_OUTLINE,
  solicitudestudios: icons.NOTE_EDIT_OUTLINE,
});

export default icons;
